export default __webpack_public_path__ + "images/4e0563b5894188453fb9ff5ab2a69e2f-fuel.png";